import React, { useState, useEffect } from "react";
import { Button, Row, Col, FormGroup } from "reactstrap";
import captchImg from "../assets/images/captchaImg.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "react-bootstrap/Modal";
import { BiLike, BiDislike, BiSolidLike, BiSolidDislike } from "react-icons/bi";
import { FaSquareXTwitter } from "react-icons/fa6";
import StateList from '../../src/helper/State_List.json';
import DistrictList from '../../src/helper/District_List.json';
import axiosConn from "config/axiosConn";
import CollaborationModel from "./CollaborationModel.jsx"
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import Helper from "../helper/Common_Helper";
import { FacebookShareButton, WhatsappShareButton, WhatsappIcon, TwitterShareButton, LinkedinShareButton, FacebookIcon, LinkedinIcon } from 'react-share';
import { setCharacterSpacing } from "pdf-lib";
import SpinnerOverlay from "./SchoolAdmin/Spinner";
import { useSelector } from "react-redux";


function CommonViewtheme() {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [show, setShow] = useState(false);
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [filteredSchool, setFilteredSchool] = useState([]);
  const [selectedState, setState] = useState('');
  const [stateName, setStateName] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [selectedDistrict, setDistrict] = useState('');
  const [selectedEventId, setSelectedEventId] = useState({});
  const [eventsData, setEventsData] = useState([]);
  const [schoolID, setSchoolId] = useState('');
  const [districtID, setDistrictID] = useState('');
  const [mediaUrl, setMediaUrl] = useState('');
  const [theme_name, setTheme_name] = useState('');
  const [sub_themes, setSub_themes] = useState('');
  const [role, setRole] = useState('');
  const [udise_id, setUdise] = useState('');
  const [myschoolName, setMyschoolName] = useState('');
  const [isLogin, setIsLogin] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [userID, setUserID] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showSchoolList, setShowSchoolList] = useState(false);
  const userData = useSelector(state => state.auth.user);

  useEffect(() => {
    // let token = localStorage.getItem('token');
    let theme_name = localStorage.getItem('theme_name');
    let sub_themes = localStorage.getItem('sub_themes');
    setTheme_name(theme_name || "");
    setSub_themes(sub_themes || "");
    
    if (userData) {
      
      // let auth = jwtDecode(token)
      //getThemeList({ theme_name, sub_themes, selectedState, selectedDistrict,auth });
      // console.log(auth,"auth")

      setUdise(userData.udise_id);
      setMyschoolName(userData.school_name);
      setUserID(userData.udise_id);
      setRole(userData.role);
      setIsLogin(true);
    }
  }, []);

  // const getThemeList = async (data, page = 1) => {
  //   try {
  //     if (data) {
  //       data.page = page;
  //       data.limit = 9;
  //       data.udise_id = parseInt(data.udise_id, 10);
  //     }
  //      console.log('744444444444444444',data);
  //     const response = await fetch(
  //       `https://ecoclubs.education.gov.in/api/get-home-themes`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(data),
  //       }
  //     );
  //     const responseData = await response.json();
  //     // console.log('86866666666',responseData);
  //     if (responseData.status === "success") {
  //       const transformedEvents = responseData.data;
  //       if (transformedEvents.length === 0) {
  //         setEventsData(0);
  //       } else {
  //         setEventsData(transformedEvents);
  //       }
  //       setTotalPages(responseData.totalPages);
  //       setCurrentPage(responseData.currentPage);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getThemeListDashboard = async (page = 1) => {
    try {
      const theme_name = localStorage.getItem('theme_name'); 
      const sub_themes = localStorage.getItem('sub_themes');
      if (theme_name && sub_themes) {  
        const data = {
          theme_name: theme_name,
          sub_themes: sub_themes,   
          page: page,               
          limit: 9                  
        };
        console.log('data', data);
        let response = await axiosConn('post', "get-home-themes", data);
        if (response.data.status === "success") {
          const transformedEvents = response.data.data;
          if (transformedEvents.length === 0) {
            setEventsData(0);
          } else {
            setEventsData(transformedEvents);
          }
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.currentPage);
        }
      } else {
        console.log('theme_name not found in localStorage');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
   getThemeListDashboard();
  }, []);

  // const getthemelist2 = async (data,page = 1) => {
  //   try {
  //     if (data) {
  //       data.page = page;
  //       data.limit = 9;
  //       data.udise_id = parseInt(data.udise_id, 10);
  //     }
  //     console.log('744444444444444444  - theme2',data);
  //     const response = await fetch(
  //       `https://ecoclubs.education.gov.in/api/get-home-themes2`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //          body: JSON.stringify(data),
  //       }
  //     );
  //     const responseData = await response.json();
  //     if (Array.isArray(responseData.data)) {
  //       responseData.data.forEach(record => {
  //         console.log('Theme Name:', record.theme_name, 'Sub Themes:', record.sub_themes);
  //       });
  //     } else {
  //       console.log('Unexpected data format:', responseData.data);
  //     }
  //     if (responseData.status === "success") {
  //       const transformedEvents = responseData.data;
  //       if (transformedEvents.length === 0) {
  //         setEventsData(0);
  //       } else {
  //         setEventsData(transformedEvents);
  //       }
  //       setTotalPages(responseData.totalPages);
  //       setCurrentPage(responseData.currentPage);
        
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  // state/district search: approved events filtered by theme/sub-theme on the
  // server, newest first, 9 per page (was: fetch-everything + client filtering)
  const getthemelist2 = async (data, page = 1) => {
    try {
      setLoading(true);  // Start loading

      const postData = {
        ...data,
        theme_name: localStorage.getItem('theme_name') || data?.theme_name || '',
        sub_themes: localStorage.getItem('sub_themes') || data?.sub_themes || '',
        page,
        limit: 9,
      };

      const response = await axiosConn('post', 'get-home-themes2', postData);
      if (response.data.status === 'success') {
        const transformedEvents = response.data.data;
        if (!Array.isArray(transformedEvents) || transformedEvents.length === 0) {
          setEventsData(0);
        } else {
          setEventsData(transformedEvents);
        }
        setTotalPages(response.data.totalPages || 1);
        setCurrentPage(response.data.currentPage || page);
      } else {
        setEventsData(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  


  // windowed page numbers around the current page for the pagination bar
  const pageNumbers = () => {
    const windowSize = 5;
    let start = Math.max(1, currentPage - Math.floor(windowSize / 2));
    let end = Math.min(totalPages, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);
    const pages = [];
    for (let p = start; p <= end; p += 1) pages.push(p);
    return pages;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      document.querySelector('.dashbrdTopSrchDiv')?.scrollIntoView({ behavior: 'smooth' });
      if (schoolID) {
        getSchoolThemeList(page);
        return;
      }
      if (stateName || districtName) {
        getthemelist2({ theme_name, sub_themes, state: stateName, district: districtName }, page);
        return;
      }
      // no filters chosen: paginate the default theme-wide list
      getThemeListDashboard(page);
    }
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleSelectState = (data) => {
    setDistrict('');
    setSchoolId('')
    setSchoolName('')
    setDistrictName('')
    setFilteredSchool([])
    setState(data);
    let state = StateList.find(obj => obj.state_id == data)?.state_name;
    setStateName(state);
    let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
  }

  // const handleFilterInDistrict = async (value) => {
  //   setDistrictID(value);
  //   setFilteredSchool([]);
  //   setSchoolId('');
  //   let district = DistrictList.find(obj => obj.district_id == value)?.district_name;
  //   setDistrictName(district);
  //   let data = { state: selectedState, district: value };
  //   // console.log('18000000000000000', data);
  //   const response = await fetch(`https://ecoclubs.education.gov.in/api/get-home-themes-school`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(data),
  //   });
  //   const responseData = await response.json();
  //   // console.log('183333333333333333', responseData);
  //   if (responseData.length > 0) {
  //     const schoolNames = responseData[0].schoolData.filter((school, index, self) =>
  //       index === self.findIndex((s) => (s.udise_id === school.udise_id && s.school_name === school.school_name))
  //     ).map(school => ({ udise_id: school.udise_id, school_name: school.school_name }));
  //     // console.log('19666666', schoolNames);
  //     setFilteredSchool(schoolNames);
  //   } else {
  //     setFilteredSchool([]);
  //   }
  // };

  const handleFilterInDistrict = async (value) => {
    setDistrictID(value);
    setFilteredSchool([])
    setSchoolId('')
    setSchoolName('')
    let district = DistrictList.find(obj => obj.district_id == value)?.district_name;
    setDistrictName(district);
    let data = { state_id: selectedState, district_id: value }
    // console.log('18000000000000000', data); 
    let response = await axiosConn('post', 'get-school-filter', data)
    if (response.data.status === 'success') {
      setFilteredSchool(response.data.result)
    }
  }

  // live school-name search within the selected state/district so schools
  // that are not in the first 100 records can still find themselves
  const filterSchoolList = async (value) => {
    try {
      setSchoolId('')
      setSchoolName(value)
      setShowSchoolList(true)
      if (value.trim().length >= 3) {
        let data = { state_id: selectedState, school_name: value.trim(), limit: 10 };
        if (districtID) {
          data.district_id = districtID;
        }
        let response = await axiosConn('post', 'get-school-filter', data);
        if (response.data.status === 'success') {
          setFilteredSchool(response.data.result);
        }
      } else if (value.trim().length === 0 && districtID) {
        // restore the default district list when the box is cleared
        handleFilterInDistrict(districtID);
      } else {
        setFilteredSchool([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectSchool = (school) => {
    setSchoolId(school.udise_id);
    setSchoolName(school.school_name);
    setShowSchoolList(false);
  };

  // fetch this school's approved events for the selected theme/sub-theme
  // directly by UDISE (server-side match, paginated)
  const getSchoolThemeList = async (page = 1) => {
    try {
      setLoading(true);
      const data = {
        theme_name: localStorage.getItem('theme_name') || theme_name,
        sub_themes: localStorage.getItem('sub_themes') || sub_themes,
        udise_id: schoolID,
        page,
        limit: 9,
      };
      const response = await axiosConn('post', 'get-home-themes', data);
      if (response.data.status === 'success') {
        const transformedEvents = response.data.data;
        if (transformedEvents.length === 0) {
          setEventsData(0);
        } else {
          setEventsData(transformedEvents);
        }
        setTotalPages(response.data.totalPages);
        setCurrentPage(response.data.currentPage);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    // a specific school was picked: match its events directly by UDISE so
    // the school always finds its own events for this theme/sub-theme
    if (schoolID) {
      getSchoolThemeList(1);
      return;
    }
    let data = { theme_name, sub_themes };
    if (stateName) {
      data['state'] = stateName;
    }
    if (districtName) {
      data['district'] = districtName;
    }
    if (theme_name) {
      data['theme_name'] = theme_name;
    }
    if (sub_themes) {
      data['sub_themes'] = sub_themes;
    }
    // getThemeList(data)
     getthemelist2(data)
  }

  

  const handleMediaClick = (url, type) => {
    setMediaUrl(url);
    setIsVideo(type === 'video');
    setModalShow(true);
  };

  const handleEventCollabrate = (e, data) => {
    e.preventDefault();
    localStorage.removeItem('selectedLanguage')
    localStorage.removeItem('show')
    localStorage.removeItem('hideTranslationButton')
    localStorage.removeItem('key')
    if (isLogin === false) {
      toast.warning("Please login to Collaborate."); return;
    }
    setModalShow1(true);
    setSelectedEventId(data)
  };

  const handleLikeDisLike = async (UID, action) => {
    try {
      let postdata = { UID, action }
      postdata['userID'] = userID;
      postdata['role'] = role;
      let response = await axiosConn('post', 'like-dislike', postdata)
      if (response.data.status === 'success') {
        // getThemeList({ theme_name, sub_themes, selectedState, selectedDistrict })
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleShare = (item) => {
    const shareUrl = window.location.href; // The URL of your event
    const title = item.event_name;
    const message = `Check out this event recently uploaded on Eco Club portal: ${title}`;
    const whatsappMessage = `Check out this event recently uploaded on Eco Club portal: *${title}*`;

    return (
      <div className="share-buttons">
        <FacebookShareButton url={shareUrl} quote={message}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} title={message}>
          <FaSquareXTwitter size={32} round />
        </TwitterShareButton>

        <LinkedinShareButton url={shareUrl} title={title} summary={message}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>

        <WhatsappShareButton url={shareUrl} title={whatsappMessage}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>
    );
  };

  return (
    <>
    {loading && <SpinnerOverlay />}

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Report an Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="reportImgDiv">
            <form action="">
              <div className="form-group">
                <label htmlFor="">Remarks</label>
                <textarea name="" id="" cols="30" rows="10" className="form-control" ></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="">Security Pin</label>
                <img src={captchImg} alt="" />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="button green btn-login-signup loginBtnnewhm reprtBtn" onClick={() => setShow(false)}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="content">
        <div className="dashbrdTopSrchDiv text-center">
          <div className="row justify-content-center">
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="srch-opt">
                <Col md="12">
                  <FormGroup>
                    <select name="state" className="form-control" style={{ fontSize: '18px', height: '40px', overflowY: 'auto' }} onChange={(e) => handleSelectState(e.target.value, e.target.options[e.target.selectedIndex].text)}>
                    <option value="">Select State</option>
                      {StateList.map((list, i) => (
                        <option key={i} value={list.state_id}>{list.state_name}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
              </div>
            </div>
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="srch-opt">
                <Col md="12">
                  <FormGroup>
                    <select name="district" className="form-control" style={{ fontSize: '18px', height: '40px', overflowY: 'scroll' }}
                      onChange={(e) => { handleFilterInDistrict(e.target.value, e.target.options[e.target.selectedIndex].text) }}>
                      <option value="">Select District</option>
                      {filterDistrict.map((list, i) => (
                        <option key={i} value={list.district_id}>{list.district_name}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
              </div>
            </div>
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-5">
              <div className="srch-opt">
                <Col md="12">
                  <FormGroup className="schoolSearchBox">
                    <input
                      type="text"
                      name="school"
                      className="form-control"
                      placeholder="Search / Select School Name"
                      autoComplete="off"
                      value={schoolName}
                      style={{ fontSize: '16px', height: '40px' }}
                      onChange={(e) => filterSchoolList(e.target.value)}
                      onFocus={() => setShowSchoolList(true)}
                      onBlur={() => setTimeout(() => setShowSchoolList(false), 200)}
                    />
                    {showSchoolList && filteredSchool.length > 0 && (
                      <ul className="schoolSuggestList">
                        {filteredSchool.slice(0, 10).map((school, i) => (
                          <li
                            key={i}
                            onMouseDown={() => handleSelectSchool(school)}
                          >
                            {school.school_name}
                            <small> ({school.udise_id})</small>
                          </li>
                        ))}
                      </ul>
                    )}
                    {showSchoolList && schoolName.trim().length > 0 && schoolName.trim().length < 3 && filteredSchool.length === 0 && (
                      <ul className="schoolSuggestList">
                        <li className="schoolSuggestHint">Type at least 3 letters to search your school</li>
                      </ul>
                    )}
                  </FormGroup>
                </Col>
              </div>

            </div>
            <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-1">
              <div className="srch-opt">
                <Col md="12">
                  <FormGroup>
                    <button type="submit" onClick={() => handleSearch()} className="button green btn-login-signup loginBtnnewhm hdrBtnSrch" style={{ fontSize: '16px', padding: '20px 25px' }} >
                      Search
                    </button>
                  </FormGroup>
                </Col>
              </div>
            </div>
          </div>
        </div>
        <div className="imageListShowDiv">
          <Row>
            <Col md="12">
              <div className="collbrateBtn" style={{marginTop:30}}>
                <a href="/impactenergy"
                  className="button green btn-login-signup loginBtnnewhm impctBtn" >
                  Impact
                </a>
              </div>
            </Col>

            {eventsData && eventsData.length > 0 ? (
              eventsData.map((item, i) => {
                const media = [
                  ...item.photos.map((pics) => ({ type: 'image', url: pics })),
                  ...item.videos.map((vid) => ({ type: 'video', url: vid })),
                ];
                return (
                  <Col md="4" key={i}>
                    <div className="viewThemeDiv">
                      <div className="flip-card">
                        <div className="flip-card-inner">
                        <div className={`${item.photos[0]?.photo_url ? 'flip-card-front2':'flip-card-front'}`}>
                            <div className="flip-card-front-in">
                              <img src={
                                            item.photos
                                              ? item.photos[0]?.photo_url
                                              : ""
                                          } alt="Use LED bulbs/ tube-lights" />
                              <div className="frontThemName">
                                <h1> Event Name: <strong>{item.event_name ? item.event_name : ""}</strong></h1>
                              </div>
                            </div>
                          </div>
                          <div className="flip-card-back">
                            <div className="flipCardBackIn">
                              <h1> Event Name: <strong>{item.event_name ? item.event_name : ""}</strong></h1>
                              <p> Theme  Name: <strong>{item.theme_name ? item.theme_name : ""}</strong></p>
                              <p>Sub Theme:
                                          <strong>{item.sub_themes? sub_themes: ""}</strong>
                                        </p>
                                        <p>Event Date:
                                          <strong>{item.event_date? Helper.formatDate(item.event_date): ""}</strong>
                                        </p>
                              <p> Mode of Implementation: <strong>{item.implemnt_mode ? item.implemnt_mode : ""}</strong></p>
                              <p> Type of Event: <strong>{item.event_type ? item.event_type : ""}</strong></p>
                              <p> Number of Events: <strong>{item.number_events ? item.number_events : ""}</strong></p>
                              <p>  Does this Event include a technological intervention?: <strong>{item.isEventTechIntervention ? item.isEventTechIntervention : ""}</strong></p>
                              <p> Have All Participants Attending Event Taken The Pledge?: <strong>{item.haveParticipantPledge ? item.haveParticipantPledge : ""}</strong></p>
                              <p> Number of Participants:<strong>{Number.isInteger(item.number_participant_age3to8 + item.number_participant_age8to11 + item.number_participant_age11to14 + item.number_participant_age14to18 + item.number_participant_age18plus) ? (item.number_participant_age3to8 + item.number_participant_age8to11 + item.number_participant_age11to14 + item.number_participant_age14to18 + item.number_participant_age18plus) : "Invalid data"}</strong></p>
                              <p> Age 3-8 Yrs: <strong>{Number.isInteger(item.number_participant_age3to8) ? item.number_participant_age3to8 : "Invalid data"}</strong></p>
                              <p> Age 8-11 Yrs: <strong>{Number.isInteger(item.number_participant_age8to11) ? item.number_participant_age8to11 : "Invalid data"}</strong></p>
                              <p> Age 11-14 Yrs: <strong>{Number.isInteger(item.number_participant_age11to14) ? item.number_participant_age11to14 : "Invalid data"}</strong></p>
                              <p> Age 14-18 Yrs: <strong>{Number.isInteger(item.number_participant_age14to18) ? item.number_participant_age14to18 : "Invalid data"}</strong></p>
                              <p> Age 18+ Yrs: <strong>{Number.isInteger(item.number_participant_age18plus) ? item.number_participant_age18plus : "Invalid data"}</strong></p>
                              <p> State: <strong>{item.state ? item.state : ""}</strong></p>
                              <p> District: <strong>{item.district ? item.district : ""}</strong></p>
                              <p> City: <strong>{item.city ? item.city : ""}</strong></p>
                            </div>
                          </div>
                        </div>

                        <div className="themCarslDiv">
                        <Slider {...settings}>
                                      {/* {console.log} */}
                                      {media.map((mediaItem, j) => (
                                        <div className="slide01newnew" key={j}>
                                          <div
                                            className="btn-login-signup"
                                            onClick={() =>
                                              handleMediaClick(
                                                mediaItem.type === "image" ? mediaItem?.url?.photo_url : mediaItem.url,
                                                mediaItem.type
                                              )
                                            }
                                          >
                                            {mediaItem.type === "image" ? (
                                              <img
                                                src={
                                                  mediaItem?.url?.photo_url
                                                }
                                                alt="Slider Media"
                                              />
                                            ) : (
                                              <video
                                                style={{
                                                  width: "100%",
                                                  height: 71,
                                                }}
                                              >
                                                <source
                                                  src={
                                                    mediaItem.url
                                                  }
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </Slider>
                        </div><div className="actionBtnDivnew">
                          <ul>
                            <li>
                              {item?.like_person && item.like_person.length > 0 ?
                                item.like_person.some(list => list.userID === userID && list.role === role) ? (
                                  <><BiSolidLike color="#089c1e" size={26} /></> // {item.like_count ? item.like_count : ""}
                                ) : (
                                  <><BiLike size={26} onClick={() => handleLikeDisLike(item.UID, "like")} /></>
                                )
                                : (
                                  <><BiLike size={26} onClick={() => handleLikeDisLike(item.UID, "like")} /></>
                                )}
                            </li>
                            <li>
                              {item?.dislike_person && item.dislike_person.length > 0 ?
                                item.dislike_person.some(list => list.userID === userID && list.role === role) ? (
                                  <><BiSolidDislike size={26} color="#f04" /> </> //{item.dislike_count ? item.dislike_count : ""}
                                ) : (
                                  <><BiDislike size={26} onClick={() => handleLikeDisLike(item.UID, "dislike")} /> </>
                                )
                                : (
                                  <><BiDislike size={26} onClick={() => handleLikeDisLike(item.UID, "dislike")} /></>
                                )}
                            </li>
                            <li  >{handleShare(item)} </li>
                            {item.udise_id !== udise_id ?
                              <li>
                                <a onClick={(e) => { handleEventCollabrate(e, { myUDISE: udise_id, myschoolName: myschoolName, event_name: item.event_name, UID: item.UID, id: item._id, udise_id: item.udise_id, school_name: item.school_name, lang: item.lang }) }} className="reportLnk green" >+ Collaborate</a>
                              </li>
                              : <></>}
                          </ul>
                        </div>

                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <p>Event not found.</p>
            )}
          </Row>
          {totalPages > 1 ?
            <div className="eventGalleryPagination mb-3">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || loading}>&laquo; Previous</button>
              {pageNumbers().map((p) => (
                <button
                  key={p}
                  className={p === currentPage ? "active" : ""}
                  onClick={() => handlePageChange(p)}
                  disabled={loading}
                >
                  {p.toLocaleString("en-IN")}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || loading}>Next &raquo;</button>
              <span className="paginationInfo">Page {currentPage.toLocaleString("en-IN")} of {totalPages.toLocaleString("en-IN")}</span>
            </div>
            : ""}
        </div>
      </div>

      <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} mediaUrl={mediaUrl} isVideo={isVideo} setModalShow={(value) => { setModalShow(value) }} />
      <CollaborationModel show={modalShow1} onHide={() => setModalShow1(false)} eventid={selectedEventId} />
    </>
  );
}

export default CommonViewtheme;

function MyVerticallyCenteredModal(props) {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <span onClick={() => props.setModalShow(false)} className="closebtn">X</span>
      <Modal.Body style={{ padding: 20 }}>
        {props.isVideo ? (
          <video controls style={{ width: '100%', height: 500 }}>
            <source src={props.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={props.mediaUrl} alt="" style={{ width: '100%' }} />
        )}
      </Modal.Body>
    </Modal>
  );
}